import { Flex, Image, Text } from "@chakra-ui/react"
import React, { useEffect, useRef, useState } from "react"
import { ConnectionUseCase } from "@/usecases/connection"
import fileIcon from "@/assest/ic_file_present.svg"

const toastId = "full-screen-unvideo-element-tag"

// 云电脑端禁止安装安全/虚拟化软件：右上角通知卡片，4 秒自动消失。
// 对齐 android _onBlockAppInstallation 的 NotificationManager.show(
// type: "blockAppInstallation", autoDismiss: true, overrideSameType: true)：
// 重复收到消息时覆盖旧卡片并重置计时。
export const BlockAppInstallToast: React.FC = () => {
  const [open, setOpen] = useState(false)
  const autoDismissTimer = useRef<number | null>(null)

  useEffect(() => {
    const blockAppInstallCallback = {
      onBlockAppInstallation: () => {
        setOpen(true)
        // 覆盖已存在的同类型卡片，重置自动消失计时（对齐 android overrideSameType）
        if (autoDismissTimer.current !== null) {
          window.clearTimeout(autoDismissTimer.current)
        }
        // 对齐 android autoDismissDuration 默认 4 秒
        autoDismissTimer.current = window.setTimeout(() => {
          setOpen(false)
          autoDismissTimer.current = null
        }, 4000)
      },
    }
    ConnectionUseCase.addBlockAppInstallCallback(blockAppInstallCallback)
    return () => {
      ConnectionUseCase.removeBlockAppInstallCallback(blockAppInstallCallback)
      if (autoDismissTimer.current !== null) {
        window.clearTimeout(autoDismissTimer.current)
        autoDismissTimer.current = null
      }
    }
  }, [])

  return (
    <Flex
      id={toastId}
      // 图标与第一行文字对齐（文字换行时保持顶部对齐，对齐 android CrossAxisAlignment.start）
      align="flex-start"
      position="fixed"
      top="16px"
      right="16px"
      width="360px"
      px="16px"
      py="14px"
      backgroundColor="rgba(48, 49, 60, 1)"
      borderRadius="12px"
      boxShadow="0 8px 24px rgba(0, 0, 0, 0.35)"
      zIndex={9999}
      overflow="hidden"
      animation="block-card-slide-in 0.28s ease-out"
      sx={{
        "@keyframes block-card-slide-in": {
          from: { transform: "translateX(110%)", opacity: "0" },
          to: { transform: "translateX(0)", opacity: "1" },
        },
      }}
      display={open ? "flex" : "none"}
    >
      <Image id={toastId} src={fileIcon} boxSize="22px" mr="10px" flexShrink={0} />
      <Text color="white" fontSize="14px">
        安全/虚拟化软件被禁止安装，请联系管理员或经销商开放安装权限
      </Text>
    </Flex>
  )
}
